   
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options, Vue  } from "vue-class-component";    
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import KDataTable from   "@/components/datatable/newdatatable.vue"  
    import Multiselect from '@vueform/multiselect' 
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth');  
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import FaltaService from "@/service/v1/sigap/FaltaService"

    @Options({
        name: "MatriculaShow",
        components: {  CardRh , KDataTable , Multiselect , BotaoSalvar },   
        emits: [  'falta-classidicada'], 
    }) 
    export default class MatriculaShow extends Vue {
          
        @authStore.Getter
        public perfis!: any

        public service = new FaltaService(); 
          
        public model: any = null ;
        public falta_tipo_id: any = null ;
        public processando = false ;
        public formulario: any  = null ;   
         
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
 
        get hasPermissaoEditar( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }

        get tipos_select(){ 
            return [ 
                { value: 1, label: 'INDEFINIDO' } ,
                { value: 2, label: 'AMPARADO' } ,
                { value: 3, label: 'SEM AMPARADO' } ,
            ]; 
        }

        public formatCPF( cpf ): string {
            return SiteUtils.formatCPF( cpf );
        }

        public formatData( data ): string {
            return SiteUtils.formatData( data );
        }

        created(){
            this.buscaFalta(); 
        }

        public statusAlterado(dados){ 
            this.buscaFalta() ;
        }

        public buscaFalta(){   
            this.processando = true ;  
            this.service.getModel( this.$route.params.id) 
            .then(response => {   
                this.model =  JSON.parse(JSON.stringify( response ));  
                this.falta_tipo_id =  this.model.falta_tipo_id ;  
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            });  
        } 

        public editar(   ) {   
            this.$router.push({name: 'sigap_falta_editar',  params: {  id: this.$route.params.id  } });
        }  

        public classificar(){   
            this.processando = true ; 
            if(this.falta_tipo_id ){
                let dados = {
                    falta_tipo_id: this.falta_tipo_id  
                }
                // this.service.classificar( this.model.id , dados ) 
                // .then(response => {   
                //     this.model = null ;
                //     this.buscaFalta();  
                //     this.$emit("falta-classidicada", null);   
                //     this.processando = false ;    
                // })
                // .catch(error => { 
                //     this.processando = false ; 
                // }); 
            } 
        } 
 
        public homologar(){   
            this.processando = true ;  
            // this.service.homologar( this.model.id   ) 
            // .then(response => {   
            //     this.buscaFalta();  
            //     this.$emit("falta-classidicada", null);   
            //     this.processando = false ;    
            // })
            // .catch(error => { 
            //     this.processando = false ; 
            // });  
        } 
   
    } 
